<app-pro-import-map-submit-header [activeStep]="2"></app-pro-import-map-submit-header>


<div class="container">
    <!-- MAPPER HEADERS START -->

    <mat-grid-list cols="3" rowHeight="2:1" class="mapper-headers">
        <mat-grid-tile class="grid-tile-left">
            <div class="tile-content">IMPORTED SHOWS</div>
            <form
            class="search-filter"
            [ngClass]="{'search-filter-focused': searchFilterFocused}"
            #searchForm="ngForm"
            
        >
            <label for="search-filter-field" class="icon" >
                <svg *ngIf="!searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
                <svg *ngIf="searchFilterFocused" xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#15151c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
            </label>
            <input
                
                name="searchString"
                type="text"
                class="txt"
                id="search-filter-field"
                placeholder="{{searchFilterFocused ? 'Search titles, networks' : 'Search'}}"
                (focus)="searchFilterFocused = true"
                (input)="getSearchVal($event.target.value)"
            >
            <input
                type="reset"
                value="Cancel"
                class="btn-reset"
                (click)="searchFilterFocused = false;keyValue = '';searchShowsByTitleNetwork()"
            >
            <input type="submit" value="Search" class="btn-submit" 
            (click)="searchShowsByTitleNetwork()">
            <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory" (ngModelChange)="unassignMapping(i)"> -->
            <!-- <mat-select class="search-category-select" [(ngModel)]="searchCategory">
                <mat-option disabled>Select a Partner Group</mat-option>
                <mat-option *ngFor="let group of partnerGroups;" [value]="group">{{group.name}}</mat-option>
            </mat-select> -->
        </form>
        </mat-grid-tile>
        <mat-grid-tile class="grid-tile-center">
            <div class="tile-content">PARTNER GROUPS</div>
        </mat-grid-tile>
        <mat-grid-tile class="grid-tile-right">
            <div class="tile-content">MAP</div>
        </mat-grid-tile>
    </mat-grid-list>

    <!-- MAPPER HEADERS END -->


    <!-- MAPPER TOOLS START -->

    <mat-grid-list cols="5" rowHeight="2:1" class="mapper-row" *ngFor="let pro of mappedPartnerPros; let i = index">

        
        <!-- DISPLAYED FOR UNRECOGNIZED SHOW NAME - START -->
        <mat-grid-tile class="input-field" *ngIf="!pro.show">

            <div class="unrecognized-show-grid">
                <mat-form-field>
                    <input class="unrecognized-show-name" matInput placeholder="" [value]="" [disabled]="true"
                        [(ngModel)]="pro.showName">
                </mat-form-field>


                <span style="color: black; cursor: pointer" (click)="openCreatePROShowModal(pro.showName)"><small>Add New Show</small></span>
                 <!-- MODIFIED VERSION WITH USER SEARCH INPUT FIELD - 9/11/24 -->
                <mat-form-field>

                    <!-- Input field with matInput to enable typing and matAutocomplete for suggestions -->
                    <input matInput placeholder="Select Existing Show" [value]="getShowDisplayValue(pro.mapToShow)"
                           [matAutocomplete]="auto" (input)="searchShows($event.target.value)" class="recognized-show-name-select">
                    
                    <!-- Autocomplete dropdown for selecting shows -->
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onShowSelected($event, pro)">
                      <mat-option *ngFor="let show of ProShows" [value]="show">
                        {{ show.title }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                <!-- <mat-form-field>

                    <mat-select (openedChange)="!$event" (appMatSelectBottomScroll)="loadMoreShows()" appMatSelectTyping
                        (appMatSelectTyping)="searchShows($event)" class="recognized-show-name-select"
                        [(ngModel)]="pro.mapToShow">
                        <mat-option disabled>Select Existing Show</mat-option>
                        <mat-option *ngFor="let show of allShows;" [value]="show">{{show.name}}</mat-option>
                    </mat-select>
                </mat-form-field> -->
            </div>

        </mat-grid-tile>
        <!-- DISPLAYED FOR UNRECOGNIZED SHOW NAME - END -->


        <!-- DISPLAYED FOR RECOGNIZED SHOW NAME - START -->
        <mat-grid-tile class="input-field" *ngIf="pro.show">
            <mat-form-field>
                <input class="recognized-show-name" matInput placeholder="" [value]="" [disabled]="true"
                    [(ngModel)]="pro.show.name">
            </mat-form-field>
        </mat-grid-tile>
        <!-- DISPLAYED FOR RECOGNIZED SHOW NAME - END -->


        <mat-grid-tile class="arrow-icon-field">
            <app-right-arrow-icon></app-right-arrow-icon>
        </mat-grid-tile>

        <!-- <mat-grid-tile class="input-field" *ngFor="let item of getSelectedGroupsLengthForPro(pro.selectedGroups); let i = index"> -->
        <mat-grid-tile class="input-field" >
            <app-select-search placeholder="Select a Partner Group" [(ngModel)]="pro.selectedGroups[i]" (ngModelChange)="unassignMapping(i)">
                <app-select-item *ngFor="let group of partnerGroups; trackBy: trackById" [value]="group">{{group.name}}</app-select-item>
            </app-select-search>

            <!-- USE BELOW IF MAPPING EPISODES TO INVIDUAL MEMBERS -->

            <!-- <ng-container *ngIf="pro.selectedGroup && pro.mapToShow && pro.mapToShow.seasons">
                <ng-container *ngFor="let member of pro.selectedGroup.members;">
                    <mat-label class="partner-label">{{member.partner.name}}</mat-label>
                    <mat-form-field>
                        <mat-select class="episode-select" [compareWith]="compareWith"
                            [placeholder]="member.selectedEpisodesCount + ' Episodes'"
                            (click)="getMappedEpisodes(pro.mapToShow)">

                            <mat-optgroup [label]="'Unrecognized Episode Names'" [disabled]="true">
                                <mat-option [disabled]="true"
                                    *ngFor="let unrecognizedEpisode of getUnrecognizedEpisodes(pro)">
                                    <span matTooltip="Episode must be mapped before it can be assigned to a partner."
                                        (click)="mapEpisode(pro.mapToShow, unrecognizedEpisode)" class="unrecognized-episode"> <app-stop-sign-icon [height]="'17'" [width]="'16'" ></app-stop-sign-icon> <span>{{unrecognizedEpisode}}</span> </span>
                                </mat-option>
                            </mat-optgroup>

                            <mat-optgroup *ngFor="let season of getSortedSeasons(pro, member)">
                                <mat-checkbox [checked]="isMemberSeason(season, member.episodes)"
                                    (change)="onSeasonChange(season, member)">
                                    {{season.name}}
                                </mat-checkbox>

                                <mat-option *ngFor="let episode of getEpisodesForSeason(pro, season, member)">
                                    <mat-checkbox [checked]="isMemberEpisode(episode, member.episodes)"
                                        (click)="onEpisodeChange($event, episode, member)">
                                        {{episode.name}}
                                    </mat-checkbox>
                                </mat-option>

                            </mat-optgroup>



                        </mat-select>
                    </mat-form-field>

                </ng-container>
            </ng-container> -->

            <!-- USE BELOW IF MAPPING EPISODES TO PARTNER GROUPS -->

            <ng-container *ngIf="pro.selectedGroups[i] && pro.mapToShow && pro.mapToShow.seasons">
                    <mat-label class="partner-label">EPISODES</mat-label>
                    <mat-select class="episode-select" [compareWith]="compareWith"
                        [placeholder]="pro.selectedGroups[i].selectedEpisodesCount + ' Episodes'"
                        (click)="getMappedEpisodes(pro.mapToShow)">

                        <mat-optgroup [label]="'Unrecognized Episode Names'" [disabled]="true">
                            <mat-option [disabled]="true"
                                *ngFor="let unrecognizedEpisode of getUnrecognizedEpisodes(pro)">
                                <span matTooltip="Episode must be mapped before it can be assigned to a partner."
                                    (click)="mapEpisode(pro.mapToShow, unrecognizedEpisode)" class="unrecognized-episode"> <app-stop-sign-icon [height]="'17'" [width]="'16'" ></app-stop-sign-icon> <span>{{unrecognizedEpisode}}</span> </span>
                            </mat-option>
                        </mat-optgroup>

                        <mat-optgroup *ngFor="let season of getSortedSeasons(pro, pro.selectedGroups[i])">
                            <mat-checkbox [checked]="isGroupSeason(season, pro.selectedGroups[i].episodes)"
                                (change)="onSeasonChange($event, season, pro.selectedGroups[i], pro)">
                                {{season.name}}
                            </mat-checkbox>

                            <mat-option *ngFor="let episode of getEpisodesForSeason(pro, season, pro.selectedGroups[i])">
                                <mat-checkbox [checked]="isGroupEpisode(episode, pro.selectedGroups[i].episodes)"
                                    (click)="onEpisodeChange($event, episode, pro.selectedGroups[i])">
                                    {{episode.name}}
                                </mat-checkbox>
                            </mat-option>

                        </mat-optgroup>
                    </mat-select>
            </ng-container>


        </mat-grid-tile>

        <mat-grid-tile class="arrow-icon-field">
            <app-right-arrow-icon></app-right-arrow-icon>
        </mat-grid-tile>

        <mat-grid-tile class="checkbox-field">
            <section class="" [ngClass]="{'selected-checkbox' : pro.isMapped, 'unselected-checkbox' : !pro.isMapped}">
                <mat-checkbox [(ngModel)]="pro.isMapped" class="assign-checkbox"
                    (click)="$event.preventDefault();$event.stopPropagation();assignMapping($event, pro, i)"></mat-checkbox>
                <!-- <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox> -->
            </section>
            <!-- </form> -->
        </mat-grid-tile>


    </mat-grid-list>

    <!-- MAPPER TOOLS END -->

    <mat-paginator *ngIf="mappedPartnerPros"
    #paginatorPage
    [length]="allShowsCount"
    [pageIndex]="currentPage" 
    [pageSize]="25" 
    [pageSizeOptions]="[25, 100]"
    showFirstLastButtons aria-label="Select page"
    (page)="changePage($event)">
    </mat-paginator>



</div>

<div class="loading-overlay" *ngIf="isSearchingShows || isLoadingInitialShows">
    <app-loader color="#50e3c2"></app-loader>
</div>
